import { Component, computed, input, OnInit, output, signal } from '@angular/core';
import { IAssetContainer } from '../insights-review-item.component';
import { APIService } from 'app/shared/api.service';

@Component({
  selector: 'app-insights-review-issue-tracking',
  standalone: false,
  templateUrl: './insights-review-issue-tracking.component.html',
  styleUrl: './insights-review-issue-tracking.component.css'
})
export class InsightsReviewIssueTrackingComponent implements OnInit {

  assets = input.required<IAssetContainer[]>();

  issues = signal<IInsightsReviewIssueTracking[]>(null);
  hasRedIssues = signal(false);
  onSelected = output<IInsightsReviewIssueTracking[]>();
  issuesSelected = computed(() => this.issues().filter(issue => issue.selected).length);

  constructor(private apiService: APIService) {
  }

  ngOnInit(): void {
    this.issues.set(this.assets().filter(asset => asset.annotation.rag !== 'green').map(asset => {
      return {
        asset_id: asset.asset.id,
        asset_title: asset.asset.title,
        rag: asset.annotation.rag,
        annotation: asset.annotation.text,
        selected: false
      };
    }));
    this.hasRedIssues.set(this.issues().some(issue => issue.rag === 'red'));
  }
  addSelected() {
    this.onSelected.emit(this.issues().filter(issue => issue.selected));
  }

  addAllRedAndAmber() {
    this.onSelected.emit(this.issues().filter(issue => issue.rag !== 'green'));
  }

  issueClick(issue: any) {
    this.issues.update(issues => issues.map(i => i.asset_id === issue.asset_id ? { ...i, selected: !i.selected } : i));
  };

  addAllRed() {
    if (!this.hasRedIssues()) {
      this.apiService.toastWarn('No red issues to add');

      return;
    }

    this.onSelected.emit(this.issues().filter(issue => issue.rag === 'red'));
  }
}


export interface IInsightsReviewIssueTracking {
  asset_id: number;
  asset_title: string;
  rag: 'red' | 'amber' | 'green' | string;
  annotation: string;
  selected: boolean;
}
